import { DefaultFocusStatusModel } from "../../../models/DefaultFocusStatusModel";
import { KeyboardNavigation } from "./KeyboardNavigation";

export class ButtonGroupNavigation extends KeyboardNavigation {
    findNextFocusableElementWithinSameVariable(
        currentElement: DefaultFocusStatusModel,
        eventKey: string): DefaultFocusStatusModel | null {
        const buttonGroupArray = this.defaultFocusStatus.statuses.filter((element: DefaultFocusStatusModel) =>
            element.lookupTableGroupType === currentElement.lookupTableGroupType &&
            element.questionId === currentElement.questionId);
        const currentIndex = buttonGroupArray.indexOf(currentElement);

        if (eventKey === "ArrowRight") {
            for (let i = currentIndex + 1; i < buttonGroupArray.length; i++) {
                if (buttonGroupArray[i].elementRef.current && buttonGroupArray[i].elementRef.current.parentElement) {
                    return buttonGroupArray[i];
                }
            }
        } else if (eventKey === "ArrowLeft") {
            for (let i = currentIndex - 1; i >= 0; i--) {
                if (buttonGroupArray[i].elementRef.current && buttonGroupArray[i].elementRef.current.parentElement) {
                    return buttonGroupArray[i];
                }
            }
        }
        return null;
    }

    findNextFocusableElementWithinNextVariable(
        currentElement: DefaultFocusStatusModel): DefaultFocusStatusModel | null {
        const index = this.defaultFocusStatus.statuses.indexOf(currentElement);

        for (let i = index + 1, len = this.defaultFocusStatus.statuses.length; i < len; i++) {
            const elementFocusStatus = this.defaultFocusStatus.statuses[i];
            if (elementFocusStatus.elementId !== currentElement.elementId
                && elementFocusStatus.elementRef.current && elementFocusStatus.lookupTableGroupType !== currentElement.lookupTableGroupType) {
                if ((currentElement.lookupTableGroupType === "groupButtonPagination" &&
                    elementFocusStatus.lookupTableGroupType !== "lookupTableRow") ||
                    currentElement.lookupTableGroupType !== "groupButtonPagination") {
                    return elementFocusStatus;
                }
            }
        }
        return null;
    }

    findLastFocusableElementWithinPreviousVariable(
        currentElement: DefaultFocusStatusModel): DefaultFocusStatusModel | null {
        if (currentElement.lookupTableGroupType === "groupButtonPagination") {
            const tableRowElement = this.findNextElementInLookupTable(currentElement);
            if (tableRowElement) {
                return tableRowElement;
            }
        } else {
            let index = this.defaultFocusStatus.statuses.findIndex(element => element.questionId === currentElement.questionId);
            if (index > -1) {
                return this.defaultFocusStatus.statuses[index - 1];
            }
        }
        return null;
    }

}